// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aLac","tabsBox":"styles_tabsBox__29cVF","createButton":"styles_createButton__fNlvt"};